'use strict';

import mix from '../../../helpers/mix';

mix.loadCSS('css/social-likes-birman.css');

const options = () => {
    const params = {
        width: 600,
        height: 359,
    };

    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;

    const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

    const left = Math.round(width / 2 - params.width / 2) + dualScreenLeft;
    let top = 0;

    if (height > params.height) {
        top = Math.round(height / 3 - params.height / 2) + dualScreenTop;
    }

    return `left=${left},top=${top},width=${params.width},height=${params.height},personalbar=0,toolbar=0,scrollbars=1,resizable=1`;
};

const open = (url, name) => {
    const pageUrl = window.location.href.replace(window.location.hash, '');
    const title = document.title;

    url = url.replace('{url}', pageUrl).replace('{title}', title);

    const win = window.open(url, name, options());

    if (win) {
        win.focus();
    }
};

$('.js-social-like-facebook').click(function (ev) {
    ev.preventDefault();

    open(`https://www.facebook.com/sharer/sharer.php?u={url}`, 'facebook');
});

$('.js-social-like-twitter').click(function (ev) {
    ev.preventDefault();

    open(`https://twitter.com/intent/tweet?url={url}&text={title}`, 'twitter');
});

$('.js-social-like-plusone').click(function (ev) {
    ev.preventDefault();

    open(`https://plus.google.com/share?url={url}`, 'plusone');
});
